<div class="align-items-center bg-white d-flex min-h-100 p-10">
  <div class=" w-100 ">
    <!--    hover-scroll-->
    <ng-container *ngIf="content$ | async as content ; else laodingp">
      <ng-container *ngIf="content.length ; else nodata" >
        <div [innerHTML]="content"></div>
      </ng-container>
    </ng-container>
    <ng-template #laodingp><ngx-shimmer-loading [width]="'100%'" [height]="'600px'" ></ngx-shimmer-loading></ng-template>
    <ng-template #nodata>
      <tr>
        <td colspan="5">
          <div
            class="notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
          >
            <!--begin::Icon-->
            <i class="ki-duotone ki-design-1 fs-2tx text-primary me-4"></i>
            <!--end::Icon-->

            <!--begin::Wrapper-->
            <div class="d-flex flex-stack flex-grow-1">
              <!--begin::Content-->
              <div class="fw-semibold">
                <div class="fs-6 text-gray-700" >
                  {{'widgets.no_data' }}
                </div>
              </div>
              <!--end::Content-->
            </div>
            <!--end::Wrapper-->
          </div>
        </td>
      </tr>
    </ng-template>
    <div class="card-footer d-flex justify-content-between align-items-center mt-10" *ngIf="user$  | async as user "  >
      <div class="pointer-cursor">
        <span href="login" [inlineSVG]="'./assets/media/icons/duotune/arrows/arr096.svg'" class=" btn svg-icon svg-icon-3x pointer-cursor text-primary text-hover-info" (click)="logout()" ></span>
      </div>
      <ng-container *ngIf="user">
        <div class="d-flex flex-row justify-content-end">

          <div class="justify-content-end">
            <button (click)="acceptTerms(user)" type="button" class="btn btn-primary" [ngClass]="!hidespinner ? 'pe-none' : ''"><ng-container *ngIf="!hidespinner , else submitButtonContent ">
        <span class="indicator-progress" [style.display]="'block'">
           {{'terms.accept' |translate}}
          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </span>
            </ng-container>
              <ng-template #submitButtonContent>
                <span class="indicator-label"> {{'terms.accept' |translate}}</span>
              </ng-template>
            </button>

          </div>
        </div>
      </ng-container>

    </div>
  </div>
</div>

